import BasicLayout from "layouts/BasicLayout";
import { WiredropPrivacyPolicy } from "pages/privacy-policy";
import React from "react";

const WiredropPrivacyPolicyRoute = () => {
	return (
		<BasicLayout>
			<WiredropPrivacyPolicy />
		</BasicLayout>
	);
};

export default WiredropPrivacyPolicyRoute;
